import { useApi } from 'api/api-context';
import EvidenceFieldTable from 'components/tables/data/evidence-field/EvidenceFieldTable';
import DashboardLayout from 'layouts/dashboard/DashboardLayout';
import { ROLE_ADMIN_ID } from 'model/Role';
import { Navigate } from 'react-router-dom';
import { DASHBOARD_PAGE_PATH } from 'routes/paths';

/**
 * Page used to display evidence fields.
 */
export default function EvidenceFieldsPage() {
  const { roleId } = useApi();

  if (roleId !== ROLE_ADMIN_ID) {
    return <Navigate to={DASHBOARD_PAGE_PATH.original} replace />;
  }

  return (
    <DashboardLayout height="screen" breadcrumbs={[{ title: 'Evidenčné polia' }]}>
      <EvidenceFieldTable />
    </DashboardLayout>
  );
}
